var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85714 12.4066C6.85714 14.3001 5.32212 15.8352 3.42857 15.8352C1.53502 15.8352 0 14.3001 0 12.4066C0 10.5131 1.53502 8.97803 3.42857 8.97803C5.32212 8.97803 6.85714 10.5131 6.85714 12.4066Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9987 5.54948C23.9987 7.44303 22.4637 8.97805 20.5702 8.97805C18.6766 8.97805 17.1416 7.44303 17.1416 5.54948C17.1416 3.65593 18.6766 2.12091 20.5702 2.12091C22.4637 2.12091 23.9987 3.65593 23.9987 5.54948Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9987 19.2637C23.9987 21.1573 22.4637 22.6923 20.5702 22.6923C18.6766 22.6923 17.1416 21.1573 17.1416 19.2637C17.1416 17.3702 18.6766 15.8351 20.5702 15.8351C22.4637 15.8351 23.9987 17.3702 23.9987 19.2637Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7766 6.57808L3.42805 13.4352L2.67188 11.5221L20.0204 4.66495L20.7766 6.57808Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7766 18.3038L3.42805 11.4466L2.67188 13.3597L20.0204 20.2169L20.7766 18.3038Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.87ea3d025a807508fbe74fda8c9b62af.svg";
export { ForwardRef as ReactComponent };